import { useCallback, useEffect, useState } from 'react';
import { api } from '../../api/client';
import type { MessageDemande } from '../../types';

/** Les messages d'une demande visibles par la personne connectée (le serveur filtre : gestion = tout, personne absente = ses messages Slack). */
export function useMessagesDemande(demandeId: number | null) {
  const [messages, setMessages] = useState<MessageDemande[]>([]);
  const [chargement, setChargement] = useState(demandeId != null);
  const [erreur, setErreur] = useState<string | null>(null);

  const charger = useCallback(async () => {
    if (demandeId == null) { setMessages([]); setChargement(false); return; }
    try {
      setMessages(await api.getMessagesDemande(demandeId));
      setErreur(null);
    } catch (err) {
      setErreur(err instanceof Error ? err.message : 'Les messages ne se sont pas chargés.');
    } finally {
      setChargement(false);
    }
  }, [demandeId]);

  useEffect(() => { setChargement(demandeId != null); void charger(); }, [demandeId, charger]);
  return { messages, chargement, erreur, recharger: charger };
}
